import { motion } from 'framer-motion';
import { alpha } from '@mui/material';

const MotionSvg = motion.svg;
const MotionCircle = motion.circle;

interface ExpandingDigitalRingProps {
  isMobile: boolean;
  primaryColor: string;
  delay?: number;
}

export const ExpandingDigitalRing = ({ isMobile, primaryColor, delay = 0.8 }: ExpandingDigitalRingProps) => {
  // LandingTopのコピーに合わせた広めのサイズ
  const ringWidth = isMobile ? 300 : 480;
  const ringHeight = isMobile ? 200 : 280;

  return (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: isMobile ? '50%' : '40%',
      transform: 'translate(-50%, -50%)',
      zIndex: 0,
      pointerEvents: 'none',
      width: `${ringWidth}px`,
      height: `${ringHeight}px`,
    }}>
      <MotionSvg
        width="100%"
        height="100%"
        viewBox={`0 0 ${ringWidth} ${ringHeight}`}
        fill="none"
        initial="hidden"
        animate="visible"
      >
        <MotionCircle
          cx={ringWidth / 2}
          cy={ringHeight / 2}
          r={(Math.min(ringWidth, ringHeight) / 2) - 10}
          stroke={primaryColor}
          strokeWidth="1.2"
          strokeOpacity={0.25}
          strokeLinecap="round"
          // 拡大しながら描画するアニメーション
          variants={{
            hidden: { pathLength: 0, scale: 0.6, rotate: -120, opacity: 0 },
            visible: { 
              pathLength: 1, 
              scale: 1.0, 
              rotate: 0, 
              opacity: 1,
              transition: { 
                pathLength: { duration: 2.2, delay, ease: [0.22, 1, 0.36, 1] },
                scale: { duration: 2.5, delay, ease: [0.16, 1, 0.3, 1] }, // 拡大の動きを強調
                rotate: { duration: 2.8, delay, ease: "easeOut" },
                opacity: { duration: 0.8, delay }
              } 
            }
          }}
          style={{
            transformOrigin: 'center',
            scaleX: ringWidth / ringHeight, // 楕円を維持
          }}
          strokeDasharray="150 1000"
        />
      </MotionSvg>

      {/* 中心から広がる光の溜まり（拡大アニメーション付） */}
      <motion.div
        initial={{ opacity: 0, scale: 0.3 }}
        animate={{ opacity: 0.4, scale: 1 }}
        transition={{ duration: 2.0, delay: delay + 0.5, ease: "easeOut" }}
        style={{
          width: isMobile ? '180px' : '350px',
          height: isMobile ? '120px' : '220px',
          background: `radial-gradient(circle, ${alpha(primaryColor, 0.3)} 0%, transparent 70%)`,
          filter: 'blur(25px)',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: -1
        }}
      />
    </div>
  );
};